import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
import { reactive, watch, ref, computed } from 'vue';
import { useFormChanged } from '@/hooks';
import { XEditorLayout } from '@/components';
import { KpiClassifySelect, modal } from '@/share/components';
import { omit } from '@/utils';

import { useComponentModalInstance } from '/Users/ytx/ytx/projects/jxpj/web/jxpj-client/src/share/hooks/common/index.js';
import { fetchApi } from '/Users/ytx/ytx/projects/jxpj/web/jxpj-client/src/server/auto-import.js';
export default {
  __name: 'cate-editor-form',
  props: {
    id: {
      type: String,
      default: ''
    },
    projId: {
      type: String,
      default: ''
    },
    parentId: {
      type: String,
      default: ''
    },
    level: {
      type: Number,
      default: 0
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    const formRef = ref();
    const modalInst = useComponentModalInstance();
    const props = __props;
    const parentId = ref(props.parentId);
    const parentInfo = reactive({
      name: ''
    });
    const formData = reactive({
      name: '',
      compareMode: 1,
      // 不使指标值
      namePath: '',
      order: 0,
      level: 0,
      classify: 0,
      scoreWeight: 1.0
    });
    const oldFormData = reactive({});
    const {
      isChanged,
      reset
    } = useFormChanged(oldFormData, formData);
    const rules = reactive({
      name: [{
        trigger: 'blur',
        required: true,
        message: '指标分类名称不能为空'
      }]
    });
    const {
      loading,
      error,
      runAsync: getProjKpiItemDetail
    } = fetchApi('kpi.projKpiItem.getDetail');
    const {
      runAsync: getParentProjKpiItemDetail
    } = fetchApi('kpi.projKpiItem.getDetail');
    const {
      loading: saveLoading,
      runAsync: saveProjKpiItem
    } = fetchApi('kpi.projKpiItem.save');
    const loadDetail = async id => {
      if (!id) return;
      const {
        error,
        ...res
      } = await getProjKpiItemDetail({
        id
      });
      if (error) return;
      parentId.value = res.parentId || '';
      Object.assign(oldFormData, res);
      Object.assign(formData, res);
      reset();
    };
    const classifyVisible = computed(() => {
      return !props.id && props.level === 0 || !!props.id && (formData.level === 0 || formData.classify === 0);
    });
    const loadParentInfo = async id => {
      if (!id) {
        parentInfo.name = '顶层指标';
        return;
      }
      const {
        error,
        ...res
      } = await getParentProjKpiItemDetail({
        id
      });
      if (error) return;
      const {
        classify = 0
      } = res || {};
      Object.assign(parentInfo, res);
      formData.classify = classify;
    };
    watch([isChanged, saveLoading], val => {
      const [b1, b2] = val;
      modalInst.setConfirmButton({
        disabled: !b1,
        loading: b2
      });
    });
    watch(() => props.id, val => {
      loadDetail(val);
    }, {
      immediate: true
    });
    watch(() => props.parentId, val => {
      parentId.value = val;
    }, {
      immediate: true
    });
    watch(parentId, val => {
      loadParentInfo(val);
    }, {
      immediate: true
    });
    const save = async () => {
      const valid = await formRef.value.validate();
      if (!valid) return false;
      const {
        error
      } = await saveProjKpiItem({
        ...formData,
        ...omit({
          id: props.id,
          parentId: props.parentId,
          projId: props.projId,
          level: props.level
        })
      });
      if (error) return false;
      modal.notification.success(`保存指标项分类${formData.name}成功`, '保存指标项');
      return true;
    };
    const onOk = async () => {
      return await save();
    };
    const onCancel = async () => {};
    __expose({
      confirmListener: onOk,
      cancelListener: onCancel,
      save
    });
    return (_ctx, _cache) => {
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_input_number = _resolveComponent("a-input-number");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_col = _resolveComponent("a-col");
      const _component_a_row = _resolveComponent("a-row");
      return _openBlock(), _createBlock(_unref(XEditorLayout), {
        ref_key: "formRef",
        ref: formRef,
        model: formData,
        rules: rules,
        loading: _unref(loading),
        error: _unref(error)
      }, {
        default: _withCtx(() => [classifyVisible.value ? (_openBlock(), _createBlock(_component_a_form_item, {
          key: 0,
          span: "12",
          label: "指标分类",
          name: "classify"
        }, {
          default: _withCtx(() => [_createVNode(_unref(KpiClassifySelect), {
            value: formData.classify,
            "onUpdate:value": _cache[0] || (_cache[0] = $event => formData.classify = $event)
          }, null, 8, ["value"])]),
          _: 1
        })) : (_openBlock(), _createBlock(_component_a_form_item, {
          key: 1,
          span: "12",
          label: "指标分类",
          name: "classify"
        }, {
          default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(['未分类', '产出指标', '效益指标', '满意度指标'][formData.classify] || '未分类'), 1)]),
          _: 1
        })), classifyVisible.value ? (_openBlock(), _createBlock(_component_a_form_item, {
          key: 2,
          span: "12",
          label: "分值权重",
          name: "scoreWeight"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input_number, {
            value: formData.scoreWeight,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => formData.scoreWeight = $event)
          }, null, 8, ["value"])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_a_form_item, {
          span: "12",
          label: "父级指标",
          name: "namePath"
        }, {
          default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(parentInfo.name), 1)]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "分类名称",
          name: "name"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: formData.name,
            "onUpdate:value": _cache[2] || (_cache[2] = $event => formData.name = $event)
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_row, {
          gutter: 10
        }, {
          default: _withCtx(() => [_createVNode(_component_a_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "排序",
              name: "order"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_input_number, {
                value: formData.order,
                "onUpdate:value": _cache[3] || (_cache[3] = $event => formData.order = $event)
              }, null, 8, ["value"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "rules", "loading", "error"]);
    };
  }
};